// navigator.clipboard is only exposed on secure origins, so the textarea +
// execCommand path is kept as a fallback for plain-http dev hosts and older
// browsers. Resolves to true/false rather than throwing so callers can just
// swap the snackbar message.
const copyToClipboard = async text => {
  if (!text) return false;

  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      // Permission denied or a non-secure origin - fall through to the legacy path.
    }
  }

  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    // Keep it out of view and unfocusable-looking, but still selectable.
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '-1000px';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, text.length);
    const copied = document.execCommand('copy');
    document.body.removeChild(textarea);
    return copied;
  } catch (error) {
    return false;
  }
};

export { copyToClipboard };
export default copyToClipboard;
